import { useHeaderStore } from '@/hooks/useHeaderStore';
import { useEffect, useRef } from 'react';

export function useUpdateHeaderHeight() {
  const headerRef = useRef<HTMLElement>(null);
  const setHeaderHeight = useHeaderStore((store) => store.setHeaderHeight);

  useEffect(() => {
    const header = headerRef.current;

    if (!header) return;

    const resizeObserver = new ResizeObserver(() => {
      setHeaderHeight(header.clientHeight);
    });

    resizeObserver.observe(headerRef.current);

    return () => resizeObserver.disconnect();
  }, [setHeaderHeight]);

  return { headerRef };
}
